import { TypedDocumentNode, gql } from '@apollo/client';

import { withFragments } from '@sorare/core/src/lib/gql';

import type { getLeagueTrackSlotsInfo_so5LeagueTrack } from './__generated__/utils.graphql';

export const getLeagueTrackSlotsInfo = withFragments(
  (so5LeagueTrack: getLeagueTrackSlotsInfo_so5LeagueTrack) => {
    const {
      maxManagerTeamsCount,
      entrySo5Leaderboard,
      mySo5LeaderboardContenders,
    } = so5LeagueTrack;

    const managerTeamBased = maxManagerTeamsCount > 0;

    // Get the first slot that is not composed with or without a contender
    const nbComposedSlots = mySo5LeaderboardContenders.filter(
      contender => contender.so5Lineup
    ).length;

    const teamsCap =
      entrySo5Leaderboard.teamsCap !== null
        ? entrySo5Leaderboard.teamsCap
        : nbComposedSlots + 1; // Infinity
    const nbSlots = managerTeamBased ? maxManagerTeamsCount : teamsCap;

    const firstNotComposedSlot =
      nbComposedSlots === nbSlots ? 0 : nbComposedSlots;

    const firstEmptySlot =
      mySo5LeaderboardContenders.length === nbSlots
        ? 0
        : mySo5LeaderboardContenders.length;

    return {
      nbSlots,
      nbComposedSlots,
      firstNotComposedSlot,
      firstEmptySlot,
      nbContenders: mySo5LeaderboardContenders.length,
    };
  },
  {
    so5LeagueTrack: gql`
      fragment getLeagueTrackSlotsInfo_so5LeagueTrack on So5LeagueTrack {
        slug
        maxManagerTeamsCount
        entrySo5Leaderboard {
          slug
          teamsCap
        }
        mySo5LeaderboardContenders(includeHiddenManagerTeam: true) {
          slug
          so5Lineup {
            id
          }
        }
      }
    ` as TypedDocumentNode<getLeagueTrackSlotsInfo_so5LeagueTrack>,
  }
);
